<script lang="ts">
	import { Guides } from "luxedo-data"
	import { Responsive } from "responsive"

	let isMobile = $derived(Responsive.isMobile)
</script>

<div id="retry-container" class:isMobile>
	<p class="heading">
		Once you have made adjustments to your setup and are ready, {Responsive.isMobile
			? "tap"
			: "click"} "Retry" to begin a new calibration.
	</p>
</div>
<div class="additional-info">
	<p>
		To learn more about calibration, check out
		<a target="_blank" href={Guides.default.Device["Calibrating Your Device"]}>this article</a>.
	</p>
	<p>
		If none of the common issues helped, checkout our <a
			target="_blank"
			href={Guides.default.Device["Troubleshooting Calibration"]}
			>detailed calibration troubleshooting guide</a
		> for advanced troubleshooting.
	</p>
</div>

<style>
	#retry-container {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		color: var(--color-text);
	}

	.heading {
		color: var(--color-text-light);
		margin-bottom: 1rem;
		font-size: var(--h2);
		line-height: 1.25rem;
	}

	p {
		margin-bottom: 0;
	}

	.additional-info a {
		color: var(--color-text);
		border-color: var(--color-alt);
		transition:
			color 250ms,
			border-color 250ms;
	}

	.additional-info a:hover {
		color: var(--color-text-light);
		border-color: var(--color-main);
	}

	.additional-info {
		justify-self: flex-end;
		color: var(--color-text);
		line-height: 1.25em;
	}

	.additional-info > p {
		font-size: var(--h3);
	}
</style>
